import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from './../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { SelectDropDownComponent } from 'ngx-select-dropdown';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { formatNumber } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { CommonVariablesService } from './../common-variables.service';
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { from } from 'rxjs';

@Component({
	selector: 'app-simple-statement-of-accounts',
	templateUrl: './simple-statement-of-accounts.component.html',
	styleUrls: ['./simple-statement-of-accounts.component.css']
})
export class SimpleStatementOfAccountsComponent implements OnInit {
	@ViewChild(SelectDropDownComponent, { "static": false })
	ngxselectRef: SelectDropDownComponent
	simplesoaform: FormGroup;
	isShow: any;
	dtTrigger: Subject<any> = new Subject();
	dtOptions: any;
	isDisableInsuredName = true;
	submitted = false;
	policyNumberDropdown: any;
	tempPolicyNumberDetails: any;
	soaGridData = [];
	policyNumber;
	fromDate: any;
	toDate: any;
	location: any;
	insuredName: any;
	producerName: any;
	inceptionDate: any;
	expiryDate: any;
	generatedBy: any;
	soaForPeriod: any;
	isShowPremium = false;
	isShowSI = false;
	policyCurrencyType: any;
	dropdownSettings: IDropdownSettings = {};
	voyageTypeData = [];
	selectedItemsRoot = [];
	selectedPolicyData: Observable<any>;
	selected: string;
	noResult = false;
	selectedPolicy: any = [];


	/*config1: any = {
		displayKey: "cust_fld_1",
		search: true,
		height: 'auto',
		placeholder: 'Please Select Policy Number',
		customComparator: () => { },
		limitTo: 10,
		moreText: 'more',
		noResultsFound: 'No results found!',
		searchPlaceholder: 'Search Policy Number',
		searchOnKey: "cust_fld_1"
	}*/

	constructor(
		private formBuilder: FormBuilder,
		private commonService: CommonService,
		private commonVariablesService: CommonVariablesService,
		private spinner: NgxSpinnerService,
		private datePipe: DatePipe,
	) { }

	/*
	* Created By : PriyaDharshini M
	* Description : Load at the time component get loaded.
	*********************************************/
	ngOnInit(){

		this.selectedPolicyData = new Observable((observer: Observer<string>) => {
			observer.next(this.selected);
			
		})
		.pipe(
			switchMap((query: string) => {
				return from(this.loadPolicyNumber(query)).pipe(
						map((data: any) => data || []),
						tap(() => noop, err => { console.log('Something goes wrong'); })
					);
			})
		);
		window.localStorage.setItem('pageName','');
		this.dtOptions = {
			dom: "frtip",
			destroy: true,

		}
		this.simplesoaform = this.formBuilder.group({
			simplesoaPolicyNumber: ['', Validators.required],
			voyageType: ['', Validators.required],
			fromDate: ['', Validators.required],
			toDate: ['', Validators.required],
			soatype: [''],
		});
		this.dropdownSettings = {
			singleSelection: false,
			idField: 'id',
			textField: 'name',
			selectAllText: 'All',
			unSelectAllText: 'UnSelect All',
			itemsShowLimit: 5,
			allowSearchFilter: true
		};
		this.simplesoaform.patchValue({ soatype: "premium" });
		
	}

	/*
	* Created By : PriyaDharshini M
	* Description : validates validateform fields.
	*********************************************/
	get f() { return this.simplesoaform.controls; }
	hideShow() {
		this.isShow = !this.isShow
	}

	/*
	* Created By : PriyaDharshini M
	* Description : Lode policy number with in dropdown.
	*********************************************/
	async loadPolicyNumber(policyNo) {
		if(policyNo.length >= 6)
		{
		this.spinner.show();
		let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/policy_list"
			let params = {
				policy_no:policyNo,
				module_name:'SOA'
			}
			let response = await this.commonService.httpGetMethod(url, '', true, params, 'Simple SOA');
		if (response.status == 0) {
				for(let i in response.data)
				{
					response.data[i].search_val = (response.data[i].cust_fld_1 || '');
				}
				return this.unique(response.data);
		}
			/*else if (response.status != -114) {
			this.commonService.errorsmsg(response.txt, 'Error');
			}*/
			this.dtTrigger.next();
		}
	}
	/*
	* Created By : PriyaDharshini M
	* Description : Removes the duplicate policy numbers from object.
	*********************************************/
	unique(obj) {
		let newArray = [];
		let uniqueObject = {};
		for (let i in obj) {
			let objTitle = obj[i].policy_ref_num;
			if(obj[i].renewal_counter)
				obj[i].cust_fld_1 = obj[i].cust_fld_1+' - '+obj[i].renewal_counter;
			uniqueObject[objTitle] = obj[i];
		}
		for (let i in uniqueObject) {
			newArray.push(uniqueObject[i]);
		}
		//this.policyNumberDropdown = newArray;
		
		return newArray
	}
	/*
	* Created By : PriyaDharshini M
	* Description : On changing the policy number data gets sets in dom fields.
	*********************************************/
	async policyNumberChange() {
		let policyData = this.selectedPolicy;
		let policyNumber = policyData.cust_fld_1.split('-');
		$('#table_simple_soa').DataTable().destroy();
		this.voyageTypeData = [];
		this.selectedItemsRoot = [];
		let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/policy_list?"
		if(policyData) {
			let params = {
				policy_no:policyNumber[0],
				policy_ref_num:policyData.policy_ref_num,
				module_name:'SOA'
			}
			let response = await this.commonService.httpGetMethod(url, '', true, params, 'Simple SOA');
			if (response.status == 0) {
				if(response.data.length > 0){
					this.fromDate = new Date(response.data[0].policy_start_date);
					this.toDate = new Date();
					this.location = response.data[0].location;
					this.insuredName = response.data[0].insured;
					this.producerName = response.data[0].producer;
					this.inceptionDate = response.data[0].policy_start_date;
					this.expiryDate = response.data[0].policy_end_date;
					this.policyNumber = response.data[0].cust_fld_1;
					this.policyCurrencyType = response.data[0].policy_currency_type;
					let userName = window.localStorage.getItem('name');
					let date = new Date();
					let currentDate = this.datePipe.transform(date,"dd-MM-yyyy HH:mm:ss");
					let fromDate = this.datePipe.transform(this.fromDate, "dd-MM-yyyy");
					let toDate = this.datePipe.transform(this.toDate, "dd-MM-yyyy");
					this.generatedBy = currentDate + ' / ' + userName;
					this.soaForPeriod = fromDate + ' - ' + toDate;
					let voyageData = [];
					for(let j=0;j< response.data[0].voyages.length;j++){
						voyageData.push({'id':response.data[0].voyages[j].value,'name':response.data[0].voyages[j].name})
					}
					this.voyageTypeData = voyageData;
					this.simplesoaform.patchValue({
						voyageType:voyageData
					})
				}
				else{
					this.commonService.errorsmsg('No data Available', 'Error');
				}
			}
			else if (response.status != -114) {
				this.commonService.errorsmsg(response.txt, 'Error');
			}
		}		
		this.soaGridData=[];
		this.dtTrigger.next();
	}
	/*
	* Created By : PriyaDharshini M
	* Description : On submiting the form data gets loaded with in DataTable.
	*********************************************/
	async submit() {
		let fromdate = new Date(this.datePipe.transform(this.fromDate, 'yyyy-MM-dd')+'T00:00:00Z');
		let todate = new Date(this.datePipe.transform(this.toDate, 'yyyy-MM-dd')+'T00:00:00Z');
		let inceptionDate = new Date(this.inceptionDate+'T00:00:00Z');
		let expiryDate = new Date(this.expiryDate+'T00:00:00Z');
		if (fromdate < inceptionDate || fromdate > expiryDate) {
			this.commonService.errorsmsg('From Date Should be Greater than Inception date and Less than Expiry date', 'Error');
			return;
		}
		if (todate < inceptionDate || todate > expiryDate) {
			this.commonService.errorsmsg('To Date Should be Greater than Inception date and Less than Expiry date', 'Error');
			return;
		}
		if (this.simplesoaform.invalid) {
			this.submitted = true;
			return;
		}

		let fromDateValue = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
		let toDateValue = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
		this.spinner.show();
		this.soaGridData = [];
		$('#table_simple_soa').DataTable().destroy();
		let selectedVoyageType='';
		for(let i=0;i<this.simplesoaform.value.voyageType.length;i++){
			if(selectedVoyageType == '')
				selectedVoyageType = this.simplesoaform.value.voyageType[i].id;
			else
				selectedVoyageType = selectedVoyageType +','+ this.simplesoaform.value.voyageType[i].id;
		}
		let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/statements/mini"
		let params = {
			//policy_ref_num: this.simplesoaform.value.simplesoaPolicyNumber.policy_ref_num,
			policy_ref_num: this.selectedPolicy.policy_ref_num,
			from_date: fromDateValue,
			to_date: toDateValue,
			policy_no: this.policyNumber,
			type: this.simplesoaform.value.soatype,
			voyage: selectedVoyageType
		}
		let response = await this.commonService.httpGetMethod(url, '', true, params, 'Simple SOA');
		if (response.status == 0) {
			for (let i = 0; i < response.data.length; i++) {
				/* if(this.simplesoaform.value.soatype  == 'premium'){ */
					if (response.data[i].Debit != ''){
						/* response.data[i].Debit = response.data[i].Debit.toFixed(2); */
						response.data[i].Debit = formatNumber(response.data[i].Debit, 'en-US', '.2');
					}
					if (response.data[i].Credit != ''){
						/* response.data[i].Credit = response.data[i].Credit.toFixed(2); */
						response.data[i].Credit = formatNumber(response.data[i].Credit, 'en-US', '.2');
					}
					if (response.data[i].Balance != ''){
						/* response.data[i].Balance = response.data[i].Balance.toFixed(2); */
						response.data[i].Balance = formatNumber(response.data[i].Balance, 'en-US', '.2');
					}
				/* } */
				this.soaGridData.push(response.data[i]);

				if (this.simplesoaform.value.soatype == 'premium') {
					this.isShowPremium = true;
					this.isShowSI = false;
				}
				else {
					this.isShowSI = true;
					this.isShowPremium = false;
				}
			}
		}
		else if (response.status != -114) {
			/* $('#table_simple_soa').DataTable().destroy();
			this.dtTrigger.next(); */
			this.commonService.errorsmsg(response.txt, 'Error');
		}
		this.dtTrigger.next();
	}
	onDateChange(value,type){
		if(value != null){
			let onchangeDate = this.datePipe.transform(value,'dd-MM-yyyy');
			let fromDate = this.datePipe.transform(this.fromDate, "dd-MM-yyyy");
			let toDate = this.datePipe.transform(this.toDate, "dd-MM-yyyy");
			if(type=='fromDate'){
				this.soaForPeriod = onchangeDate+' - '+toDate;
			}
			else{
				this.soaForPeriod = fromDate+' - '+onchangeDate;
			}
		}
	}

	/*
	* Created By : PriyaDharshini M
	* Description : Reset the entire form.
	*********************************************/
	onReset() {
		//this.ngxselectRef._value = [];
		this.selected = '';
		this.simplesoaform.reset();
		$('#table_simple_soa').DataTable().destroy();
		this.location = "";
		this.insuredName = "";
		this.producerName = "";
		this.inceptionDate = "";
		this.expiryDate = "";
		this.soaForPeriod = "";
		this.generatedBy = "";
		this.simplesoaform.patchValue({ soatype: "premium" });
		this.soaGridData = [];
		this.selectedItemsRoot = [];
		this.dtTrigger.next();
		this.submitted = false;
	}
	/*
	* Created By : PriyaDharshini M
	* Description :To generate Excel sheet.
	*********************************************/
	async generateExcel() {
		let fromdate = new Date(this.fromDate);
		let todate = new Date(this.toDate);
		let inceptionDate = new Date(this.inceptionDate);
		let expiryDate = new Date(this.expiryDate);
		if (fromdate < inceptionDate || fromdate > expiryDate) {
			this.commonService.errorsmsg('From Date Should be Greater than Inception date and Less than Expiry date', 'Error');
			return;
		}
		if (todate < inceptionDate || todate > expiryDate) {
			this.commonService.errorsmsg('To Date Should be Greater than Inception date and Less than Expiry date', 'Error');
			return;
		}
		if (this.simplesoaform.invalid) {
			this.submitted = true;
			return;
		}
		if (this.soaGridData.length == 0) {
			this.commonService.warningmsg('No data available in table', 'warning');
			return;
		}
		//font,color,image,size
		setTimeout(async () => {
			(this.spinner.show());
		}, 1000);
		let selectedVoyageType='';
		for(let i=0;i<this.simplesoaform.value.voyageType.length;i++){
			if(selectedVoyageType == '')
				selectedVoyageType = this.simplesoaform.value.voyageType[i].name;
			else
				selectedVoyageType = selectedVoyageType +','+ this.simplesoaform.value.voyageType[i].name;
		}
		var datajson = { datajson1: this.soaGridData }, headingBySelection = '';

		if (this.isShowPremium)
			headingBySelection = "MINI STATEMENT BY PREMIUM";
		else
			headingBySelection = "MINI STATEMENT BY SUM INSURED";
		var Heading = [
			[headingBySelection],
			[],
			["Policy Number", this.policyNumber + "" || ''],
			["Voyage Type", selectedVoyageType + "" || ''],
			["From Date", this.datePipe.transform(this.fromDate, "dd-MM-yyyy") || ''],
			["To Date", this.datePipe.transform(this.toDate, "dd-MM-yyyy") || ''],
			["Statement of account for period", this.soaForPeriod + "" || ''],
			["Location " , this.location + "" || ''],
			["Insured Name", this.insuredName + "" || ''],
			["Producer Name", this.producerName + "" || ''],
			["Generated On / By", this.generatedBy + "" || ''],
			["Policy Inception Date", this.datePipe.transform(this.inceptionDate, "dd-MM-yyyy") + "" || ''],
			["Policy Expiry Date", this.datePipe.transform(this.expiryDate, "dd-MM-yyyy") + "" || ''],
			[],
			["Description", "Amount in " + this.policyCurrencyType, "", "Balance in " + this.policyCurrencyType],
			["", "Debit", "Credit", ""]
		];
		const merge = [
			{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
			{ s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
			{ s: { r: 2, c: 0 }, e: { r: 2, c: 4 } },
			/* { s: { r: 6, c: 0 }, e: { r: 6, c: 4 } }, */
			/* { s: { r: 7, c: 1 }, e: { r: 7, c: 2 } } */
		];
		var wscols = [];
		// let cell;
		
		for (let i = 0; i < Heading[6].length; i++) {
			wscols.push({ wch: 25 });  // Common column width
		}
		
		var ws = XLSX.utils.json_to_sheet(Heading);
		ws['!cols'] = wscols;
		ws["!merges"] = merge;
		/* ws['A16'] = {
		  fill: {
			patternType: "none", // none / solid
			fgColor: {rgb: "FF000000"},
			bgColor: {rgb: "FFFFFFFF"}
			},
			font: {
			name: 'Times New Roman',
			sz: 16,
			color: {rgb: "#FF000000"},
			bold: true,
			italic: false,
			underline: false
			},
			border: {
			top: {style: "thin", color: {auto: 1}},
			right: {style: "thin", color: {auto: 1}},
			bottom: {style: "thin", color: {auto: 1}},
			left: {style: "thin", color: {auto: 1}}
			}
		}; */
		ws["A1"] = {
			"t": 's',
			// "v": 'TATA MARINE',
			"s": { font: { size: 20, bold: true, color: "#e012e0", style: "text-align:center" } }
		};
		XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
			//header: ["description", "debit", "credit", "balance"],
			skipHeader: true,
			origin: -1
		});
		// var alphabets = [''];
		var wb = XLSX.utils.book_new();
		await (XLSX.utils.book_append_sheet(wb, ws, "Simple Statement of Account"));
		XLSX.writeFile(wb, this.policyNumber+'_Mini_SOA.xlsx');
		setTimeout(async () => {
			(this.spinner.hide());
		}, 1000);
	}

	/*onPolicyNumberDropdown() {
		this.tempPolicyNumberDetails = JSON.parse(JSON.stringify(this.policyNumberDropdown))
		this.config1 = {
			displayKey: "cust_fld_1",
			search: true,
			height: 'auto',
			placeholder: 'Please Select Policy Number',
			customComparator: () => { },
			limitTo: 10,
			moreText: 'more',
			noResultsFound: 'No results found!',
			searchPlaceholder: 'Search policy number',
			clearOnSelection: true,
			searchOnKey: "cust_fld_1"
		}
	}
	/*
	* Created By : Manasa R
	* Description :To generate PDF.
	*********************************************/
	async generatePdf() {
		let fromdate = new Date(this.fromDate);
		let todate = new Date(this.toDate);
		let inceptionDate = new Date(this.inceptionDate);
		let expiryDate = new Date(this.expiryDate);
		if (fromdate < inceptionDate || fromdate > expiryDate) {
			this.commonService.errorsmsg('From Date Should be Greater than Inception date and Less than Expiry date', 'Error');
			return;
		}
		if (todate < inceptionDate || todate > expiryDate) {
			this.commonService.errorsmsg('To Date Should be Greater than Inception date and Less than Expiry date', 'Error');
			return;
		}
		if (this.simplesoaform.invalid) {
			this.submitted = true;
			return;
		}
		if (this.soaGridData.length == 0) {
			this.commonService.warningmsg('No data available in table', 'warning');
			return;
		}
		// let fromDateValue = this.datePipe.transform(this.fromDate,'yyyy-MM-dd');
		// let toDateValue = this.datePipe.transform(this.toDate,'yyyy-MM-dd');
		// const policyDwnldUrl = `${this.commonVariablesService.baseURL}api/v1/marine_download/pdf/marine_soa_mini/${this.policyNumber}?token=${encodeURIComponent(sessionStorage.getItem('token'))}&policy_ref_num=${this.simplesoaform.value.simplesoaPolicyNumber.policy_ref_num}&from_date=${fromDateValue}&to_date=${toDateValue}&policy_no=${this.policyNumber}&type=${this.simplesoaform.value.soatype}`;
		// window.open(policyDwnldUrl, '_blank');
		let l: any = {
			orientation: 'p',
			unit: 'mm',
			format: 'a4',
			compress: true,
			fontSize: 8,
			//lineHeight: 1,
			autoSize: false,
			printHeaders: true
		};
		let selectedVoyageType='';
		for(let i=0;i<this.simplesoaform.value.voyageType.length;i++){
			if(selectedVoyageType == '')
				selectedVoyageType = this.simplesoaform.value.voyageType[i].name;
			else
				selectedVoyageType = selectedVoyageType +','+ this.simplesoaform.value.voyageType[i].name;
		}
		const doc = new jsPDF(l);

		/* doc.text('Tagic Marine', 25, 5, { align: "left" }); */
		doc.text("Policy Number : " + this.policyNumber, 25, 10, { align: 'left' })
		doc.text("Voyage Type : " + selectedVoyageType, 25 ,15, { align: 'left' })
		doc.text("From Date : " + this.datePipe.transform(this.fromDate, "dd-MM-yyyy"), 25, 20, { align: 'left' })
		doc.text("To Date : " + this.datePipe.transform(this.toDate, "dd-MM-yyyy"), 25, 25, { align: 'left' })
		doc.text("Statement of account for period : " + this.soaForPeriod, 25, 30, { align: 'left' })
		doc.text("Location : " + this.location, 25, 35, { align: 'left' })
		doc.text("Insured Name : " + this.insuredName, 25, 40, { align: 'left' })
		doc.text("Producer Name : " + this.producerName, 25, 45, { align: 'left' })
		doc.text("Generated On / By : " + this.generatedBy, 25, 50, { align: 'left' })
		doc.text("Policy Inception Date : " + this.datePipe.transform(this.inceptionDate, "dd-MM-yyyy"), 25, 55, { align: 'left' })
		doc.text("Policy Expiry Date : " + this.datePipe.transform(this.expiryDate, "dd-MM-yyyy"), 25, 60, { align: 'left' })

		var headingBySelection = '';

		if (this.isShowPremium)
			headingBySelection = "MINI STATEMENT BY PREMIUM";
		else
			headingBySelection = "MINI STATEMENT BY SUM INSURED";

		doc.text(headingBySelection, 25, 65, { align: 'left' })
		//doc.text('Tagic Marine',10,10,options);
		let options = {
			//html: '#table_simple_soa',
			//tableLineColor: 'black',tableLineWidth: 0.25,
			body: this.soaGridData,
			head: [[{ content: "Description", colSpan: 1, rowSpan: 2 }, { content: "Amount in " + this.policyCurrencyType, colSpan: 2, rowSpan: 1 }, { content: "Balance in " + this.policyCurrencyType, colSpan: 1, rowSpan: 2 }], [{ content: "Debit", colSpan: 1, rowSpan: 1 }, { content: "Credit", colSpan: 1, rowSpan: 1 }, { content: "", colSpan: 1 }]],
			columns: [{ header: "Description", dataKey: "Description" },
			{ header: "Debit", dataKey: "Debit" },
			{ header: "Credit", dataKey: "Credit" },
			{ header: "Balance", dataKey: "Balance" },
			],
			margin: { top: 70 }, headerStyles: {
				0: { colSpan: 1 }, 1: { colSpan: 2 }, 2: { colSpan: 1, },
				halign: 'center', lineWidth: 0.1,
				lineColor: 'gray'
			}, bodyStyles: {
				lineWidth: 0.1,
				lineColor: 'gray'
			}, didDrawPage: function (data) {
				// Reseting top margin. The change will be reflected only after print the first page.
				data.settings.margin.top = 10;
			},
		}
		autoTable(doc, options)
		doc.save(this.policyNumber + "_Mini_SOA.pdf")

	}

	typeaheadNoResults(event: boolean): void {
		if ((this.commonVariablesService.gcPolicyNoFromHeaderSearch).length >= 6) {
			this.noResult = event;
		}
	}

	/*
	* Created By : Sharann N
	* Description : navigate to declaration page on dropdown select.
	*********************************************/
	async typeaheadOnSelect(e: any, isManuallyTrigger: boolean = false) {
		this.selectedPolicy = [];
		this.selected = e.value ? e.value : "";
		this.selectedPolicy = e.item
		await this.policyNumberChange()
	}
}
